var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransporteParadaBusPoste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kijhb1glwa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.431372 0 0 0 0 0.384314 0 0 0 0 0.349020 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#kijhb1glwa)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.046 0H.699C.314 0 0 .314 0 .699v8.265c0 .385.314.699.699.699h7.347c.385 0 .699-.314.699-.699V.7c0-.385-.314-.699-.7-.699zM7.84 7.19c0 .306-.248.553-.554.553h-.472v.429c0 .305-.248.553-.553.553-.306 0-.554-.248-.554-.553v-.429H3.037v.429c0 .305-.248.553-.554.553-.306 0-.553-.248-.553-.553v-.429h-.473c-.305 0-.553-.247-.553-.553V2.247c0-.722.587-1.31 1.31-1.31H6.53c.722 0 1.31.588 1.31 1.31V7.19z",
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01 6.636h4.724v-1.9H2.01v1.9zm3.516-1.501h.058c.306 0 .553.248.553.554 0 .305-.247.553-.553.553h-.058c-.306 0-.554-.248-.554-.553 0-.306.248-.554.554-.554zm-2.365 0h.058c.305 0 .553.248.553.554 0 .305-.248.553-.553.553H3.16c-.306 0-.554-.248-.554-.553 0-.306.248-.554.554-.554zM6.531 2.045H2.213c-.112 0-.202.09-.202.202v1.381h4.723V2.247c0-.112-.09-.202-.203-.202zM5.664 16.893h-.738V10.77H3.819v6.123H3.08c-.306 0-.554.248-.554.553 0 .306.248.554.554.554h2.583c.305 0 .553-.248.553-.554 0-.305-.248-.553-.553-.553z",
    transform: "translate(6)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteParadaBusPoste);
export default __webpack_public_path__ + "static/media/transporte-parada-bus-poste.dc62cf22.svg";
export { ForwardRef as ReactComponent };